/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Badge_LapsedInputs */



/**
* | output |
* | --- |
* | "Expired before it started" |
*
* @param {Partner_Org_Contract_Badge_LapsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_badge_lapsed = /** @type {((inputs?: Partner_Org_Contract_Badge_LapsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Badge_LapsedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgelaufen, bevor er begann")
	return /** @type {LocalizedString} */ ("Expired before it started")
});